import React, { useState } from 'react'
import { IconButton, InputAdornment, makeStyles, TextField } from '@material-ui/core'
import { Visibility, VisibilityOff } from '@material-ui/icons'

const PasswordField = ({ name, label, formik, ...props }) => {
  const classes = useStyles()
  const [showPassword, setShowPassword] = useState(false)

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const handleMouseDownPassword = (event) => {
    event.preventDefault()
  }

  return (
    <TextField
      className={classes.textField}
      variant="outlined"
      label={label}
      type={showPassword ? 'text' : 'password'}
      name={name}
      value={formik.values[name]}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      error={formik.touched[name] && Boolean(formik.errors[name])}
      helperText={formik.touched[name] && formik.errors[name]}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              size="small"
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end">
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        )
      }}
      fullWidth
      {...props}
    />
  )
}

export default PasswordField

const useStyles = makeStyles({
  textField: {
    marginBottom: '8px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      transition: 'all 0.3s',
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#15b4db'
      }
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#e0e0e0',
      borderWidth: '1px'
    }
  }
})
